import { render, staticRenderFns } from "./permissionForm.vue?vue&type=template&id=57db74f2&"
import script from "./permissionForm.vue?vue&type=script&lang=ts&"
export * from "./permissionForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports